import { AppEnv, AppEnvEnum } from "@novel/shared/utils/env";
import paymasterDevMumbai from "./paymaster.development.mumbai.json";
import paymasterDevPolygon from "./paymaster.development.polygon.json";
import paymasterStagingMumbai from "./paymaster.staging.mumbai.json";
import paymasterStagingPolygon from "./paymaster.staging.polygon.json";
import paymasterTestMumbai from "./paymaster.test.mumbai.json";
import paymasterTestPolygon from "./paymaster.test.polygon.json";
import paymasterProductionMumbai from "./paymaster.production.mumbai.json";
import paymasterProductionPolygon from "./paymaster.production.polygon.json";

interface PaymasterData {
    paymasterAddress: string;
    relayHubAddress: string;
    gsnTrustedForwarderAddress: string;
}

const paymasterDataLookup: {
    [key in AppEnvEnum]: {
        mumbai: PaymasterData;
        polygon: PaymasterData;
    };
} = {
    development: {
        mumbai: paymasterDevMumbai,
        polygon: paymasterDevPolygon,
    },
    staging: {
        mumbai: paymasterStagingMumbai,
        polygon: paymasterStagingPolygon,
    },
    test: {
        mumbai: paymasterTestMumbai,
        polygon: paymasterTestPolygon,
    },
    production: {
        mumbai: paymasterProductionMumbai,
        polygon: paymasterProductionPolygon,
    },
} as const;

type SupportedPaymasterBlockchains = "mumbai" | "polygon";

export function getPaymasterData(isTestnet: boolean): PaymasterData {
    return paymasterDataLookup[AppEnv][isTestnet ? "mumbai" : "polygon"];
}

export function getPaymasterDataByBlockchain(
    blockchain: SupportedPaymasterBlockchains,
): PaymasterData {
    return paymasterDataLookup[AppEnv][blockchain];
}
